export default theme => ({
  select__classification: {
    borderColor: theme.colors.threatAssocGray,
    borderWidth: 'thin',
    boxShadow: 'none',
    width: '378px',
  },
});
